<template>
    <div class="row cart-item-row">
        <div class="col-sm-12 col-md-4 col-lg-2 details-col">
            <div>
                <nuxt-link :to="item.image.link" class="image-link">
                    <img :src="item.image.thumbnails.small.url" :alt="item.image.description">
                    <div v-if="item.image.type === 'video'" class="video-timestamp">
                        <b-icon-play-circle/>
                        <span class="time-text">{{ secondsToTimestamp(item.image.duration) }}</span>
                    </div>
                </nuxt-link>
                <div>
                    <span class="small-heading">#{{ item.image.code }}</span>
                    <span class="small-heading">Shot by <strong>{{ item.image.contributor.name }}</strong></span>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-8 col-lg-10 price-col">
            <table>
                <tbody>
                    <tr>
                        <td class="align-top">
                            <span v-if="item.size" class="highlighted">
                                <template v-if="item.size.upgrade">
                                    Upgrade:
                                </template>
                                {{ t(item.size.name) }}
                                <template v-if="item.image.licences && item.image.licences.length > 1 && item.size.licence">
                                    - {{ item.image.licences.find(licence => licence.id === item.size.licence).name }}
                                </template>
                            </span>
                            <span v-if="item.size" class="small-heading">{{ `${item.size.width}px x ${item.size.height}px` }}{{ item.image.type === 'image' ? ` (${item.size.dpi}dpi)` : '' }}</span>
                            <span class="small-heading">Global Royalty-Free Licence in perpetuity.</span>
                            <span class="small-heading"><strong>{{ item.image.type.charAt(0).toUpperCase() + item.image.type.slice(1) }}</strong> exclusive to Truestock.</span>
                        </td>
                        <td v-if="item.size" class="highlighted amt-col">
                            <template v-if="hasDiscount">
                                <span class="text-crossout">{{ moneyForceDecimal(item.size.price) }}</span><br>
                                {{ discountedPrice }}
                            </template>
                            <template v-else>
                                {{ moneyForceDecimal(item.size.price) }}
                            </template>
                            <br>
                            <a class="btn btn-default btn-hollow mt-3" @click="showPricePicker">Change Size</a>
                        </td>
                        <td v-else class="amt-col">
                            <a class="btn btn-default btn-hollow" @click="showPricePicker">Select size</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-default btn-hollow remove-btn" @click="removeItem(item)">
                <b-icon-trash class="mr-2"/>
                Remove
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'CartItem',
    components: {},
    props: {
        item: {
            type: Object
        }
    },
    data () {
        return {
            sizeName: {
                xs: 'Extra Small',
                s: 'Small',
                m: 'Medium',
                l: 'Large',
                xl: 'Extra Large',
                '720p': '720p',
                '1080p': '1080p',
                '4k': '4K'
            }
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            maxPromotion: 'data/maxPromotion'
        }),
        hasDiscount () {
            return ((this.user && this.user.discount_pcnt > 0) || this.maxPromotion())
        },
        discountedPrice () {
            let discountPcntAmt = 0

            if (this.user && this.user.discount_pcnt > 0) {
                discountPcntAmt = this.user.discount_pcnt
            }

            if (this.maxPromotion() && this.maxPromotion().discount_pcnt > discountPcntAmt) {
                discountPcntAmt = this.maxPromotion().discount_pcnt
            }

            return this.moneyForceDecimal(this.item.size.price - (this.item.size.price * (discountPcntAmt / 100)))
        }
    },
    methods: {
        showPricePicker () {
            this.$emit('calculate-price', this.item.image)
        },
        removeItem (item) {
            this.$parent.removeItem(item)
        },
        t (nameCode) {
            return this.sizeName[nameCode]
        }
    }
}
</script>
